import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { UiContext } from 'uiContext';
import { ForecastItemProps } from 'components/forecast/forecastItem/forecastItemTypes';
import { getScoreThemeColor } from 'helpers/utils';
import { DateTypeStringHelper } from 'helpers/dateTimeStringHelper';
import { borderRadiusValues } from 'assets/theme';

export default function ForecastItemMobile({ dt, score }: ForecastItemProps) {
  const {
    spacings: { sp, icons },
  } = useContext(UiContext);

  const dtHelper = new DateTypeStringHelper(dt);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: sp.s15,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          width: 1,
          borderRadius: borderRadiusValues.xSmall,
          height: icons['16x16'].h,
          bgcolor: getScoreThemeColor(score),
        }}
      >
        <Typography sx={{ color: 'custom.forecastItem' }} variant="f12b">
          {score}
        </Typography>
      </Box>
      <Typography sx={{ color: 'custom.lightText' }} variant="f10">
        {dtHelper.dateTime.time}
      </Typography>
    </Box>
  );
}
